import backendRequestUtil from "../utils/backendRequest.util";

export async function getVisits(filter = {}, columnsSelected = []) {
  filter.columns = JSON.stringify(columnsSelected);
  const { success, body, error } = await backendRequestUtil.get(`/api/v2/visit`, { params: filter });
  return success ? { success, payload: body } : { success, error }
};

export async function getVisit(visitId) {
  const { success, body, error } = await backendRequestUtil.get(`/api/v2/visit/${visitId}`)
  return success ? { success, payload: body } : { success, error }
}
